"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationBase = void 0;
var core_1 = require("@inter-ikea-core/core");
var ValidationBase = /** @class */ (function () {
    function ValidationBase() {
        this._isEnabled = true;
    }
    Object.defineProperty(ValidationBase.prototype, "isEnabled", {
        get: function () {
            return this._isEnabled;
        },
        enumerable: false,
        configurable: true
    });
    ValidationBase.prototype.enable = function () {
        this._isEnabled = true;
    };
    ValidationBase.prototype.disable = function () {
        this._isEnabled = false;
    };
    ValidationBase.prototype.findRoot = function (snapActionCandidate, entity) {
        var _a;
        var mainEntity = (_a = snapActionCandidate === null || snapActionCandidate === void 0 ? void 0 : snapActionCandidate.host) !== null && _a !== void 0 ? _a : entity;
        return core_1.HierarchyUtils.rootOf(mainEntity);
    };
    return ValidationBase;
}());
exports.ValidationBase = ValidationBase;
//# sourceMappingURL=ValidationBase.js.map